import {Directive, Input} from '@angular/core';
import {NG_VALIDATORS, UntypedFormControl, Validator} from '@angular/forms';
import parseMax from 'libphonenumber-js/max';

@Directive({    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cmnPhone][formControlName], [cmnPhone][formControl], [cmnPhone][ngModel]',
    providers: [{provide: NG_VALIDATORS, useExisting: CmnPhoneDirective, multi: true}]
})

export class CmnPhoneDirective implements Validator {
    @Input() cmnPhoneCountryCode: String;

    validate(c: UntypedFormControl): { [key: string]: any } {
        return c.value && !this.isPhone(c.value) ? {invalid: true} : null;
    }

    isPhone(input?: string): boolean {
        if (this.cmnPhoneCountryCode != undefined) {
            const formatted_value = `+${this.cmnPhoneCountryCode}${input}`;
            const SMSNumber = parseMax(formatted_value);
            return input ? SMSNumber && SMSNumber.isPossible() && SMSNumber.isValid() : false;
        }
        const parsedInput = parseMax(input);
        return input ? parsedInput != undefined && parsedInput.isValid() : false;
    }
}


